import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../../../Services/auth';


@Component({
  selector: 'app-footer',
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  openSection: Set<string> = new Set();
  isMobileView: boolean = false

  public loggedIn$!: Observable<boolean>;
  public loggedIn: boolean = false;
  private authSubscription?: Subscription;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router, private authService: AuthService) { }

  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {
      this.isMobileView = window.innerWidth < 700;
    }
    // Expose auth state to template and keep a boolean copy
    this.loggedIn$ = this.authService.loggedIn$;
    this.authSubscription = this.authService.loggedIn$.subscribe(isLogged => {
      this.loggedIn = !!isLogged;
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkViewport();
    if (!this.isMobileView) {
      this.openSection = new Set(['contact', 'quick-links', 'follow-us']);
    } else {
      this.openSection.clear();
    }
  }

  checkViewport(): void {
    if (typeof window !== 'undefined') {
      this.isMobileView = window.innerWidth < 700;
    }
  }


  toggleSection(section: string): void {
    if (this.isMobileView) {
      if (this.openSection.has(section)) {
        this.openSection.delete(section);
      } else {
        this.openSection.add(section);
      }
    }
  }
  routeToHome(): void {
    this.router.navigate(['/'])
  }
  routeToPage(route: string): void {
    const targetPath = route.startsWith('/') ? route : `/${route}`;
    const currentPath = this.router.url.split('?')[0];

    if (currentPath === targetPath) {
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }

    this.router.navigate([route]).then(() => {
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
